var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hu-color-picker",
      class: { light: _vm.isLightTheme },
      style: { width: _vm.totalWidth + "px" }
    },
    [
      _c(
        "div",
        { staticClass: "color-set" },
        [
          _c("Saturation", {
            ref: "saturation",
            attrs: { color: _vm.rgbString, hsv: _vm.hsv, size: _vm.hueHeight },
            on: { selectSaturation: _vm.selectSaturation }
          }),
          _vm._v(" "),
          _c("Hue", {
            ref: "hue",
            attrs: { hsv: _vm.hsv, width: _vm.hueWidth, height: _vm.hueHeight },
            on: { selectHue: _vm.selectHue }
          }),
          _vm._v(" "),
          _c("Alpha", {
            ref: "alpha",
            attrs: {
              color: _vm.rgbString,
              rgba: _vm.rgba,
              width: _vm.hueWidth,
              height: _vm.hueHeight
            },
            on: { selectAlpha: _vm.selectAlpha }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "color-show",
          style: { height: _vm.previewHeight + "px" }
        },
        [
          _c("Preview", {
            attrs: {
              color: _vm.rgbaString,
              width: _vm.previewWidth,
              height: _vm.previewHeight
            }
          }),
          _vm._v(" "),
          !_vm.suckerHide
            ? _c("Sucker", {
                attrs: {
                  "sucker-canvas": _vm.suckerCanvas,
                  "sucker-area": _vm.suckerArea
                },
                on: {
                  openSucker: _vm.openSucker,
                  selectSucker: _vm.selectSucker
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("Box", {
        attrs: { name: "HEX", color: _vm.modelHex },
        on: { inputColor: _vm.inputHex }
      }),
      _vm._v(" "),
      _c("Box", {
        attrs: { name: "RGBA", color: _vm.modelRgba },
        on: { inputColor: _vm.inputRgba }
      }),
      _vm._v(" "),
      _c("Colors", {
        attrs: {
          color: _vm.rgbaString,
          "colors-default": _vm.colorsDefault,
          "colors-history-key": _vm.colorsHistoryKey
        },
        on: { selectColor: _vm.selectColor }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }